import { Button, FileInput, rem } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { useState } from 'react';
import { axiosWithCSRF } from '../../fetchHooks/axiosWithCSRF';
import { envApiUrl } from '../../fetchHooks/envApiUrl';

const UploadProfilePicture = () => {
  const queryClient = useQueryClient();
  const [selectedFile, setSelectedFile] = useState(null);

  const uploadProfilePicFetch = async (file, onOk, setUploadProgress) => {
    console.log('handleUploadFile file', file);
    try {
      const response = await axiosWithCSRF({
        method: 'POST',
        url: envApiUrl + '/files/profile',
        data: file,
        headers: {
          'content-type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setUploadProgress?.(progress);
        },
      });
      console.log('uploadProfilePicFetch : response: ', response);
      message.success('Successfully uploaded profile picture');
      onOk?.();
      return response.data;
    } catch (err) {
      console.error('uploadProfilePicFetch error: ', err.response?.data?.message, err);
      message.error(err.response?.data?.message || 'Failed to upload profile picture');
    }
  };

  const handleUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append('file', selectedFile);
      // Make a POST request to your server's upload endpoint
      uploadProfilePicFetch(formData, () => queryClient.invalidateQueries(['userInfo']));
    }
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <FileInput
        placeholder="Click to upload new picture"
        label="Your profile picture"
        value={selectedFile}
        onChange={setSelectedFile}
        icon={<IconUpload size={rem(14)} />}
        accept="image/png,image/jpeg"
      />

      <br />
      <Button onClick={handleUpload} variant="gradient" gradient={{ from: 'cyan', to: 'indigo' }}>
        Upload
      </Button>
    </div>
  );
};

export default UploadProfilePicture;
